<template>
    <el-input v-if="componentShow" ref="zmInput" v-model="newValue" :type="type" :disabled="disabled" :readonly="readonly"
              :maxlength="maxlength" @blur="inputBlur" :name="name" @change="inputChange" :rows="rows" @focus="inputFocus">
        <slot name="prefix" slot="prefix"></slot>
        <slot name="suffix" slot="suffix"></slot>
        <slot name="prepend" slot="prepend"></slot>
        <slot name="append" slot="append"></slot>
    </el-input>
</template>

<script>
    export default {
        name: "ZmInput",
        props: {
            type:{
                type:String,
                default:'text'
            },
            disabled:{
                type:Boolean,
                default:false
            },
            value:{
                type:[String,Number]
            },
            readonly:{
                type:Boolean,
                default:false
            },
            maxlength:{
                type:Number
            },
            trim:{
                type:Boolean,
                default:false
            },
            uppercase:{
                type:Boolean,
                default:false
            },
            name:{
                type:String
            },
            rows:{
                type:Number,
                default:2
            },
            focusSelect:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                componentShow:true
            }
        },
        computed:{
            newValue: {
                get:function() {
                    return this.value;
                    /*if(this.value){
                        let tempValue = $.trim(this.value);
                        if(this.uppercase){
                            tempValue = tempValue.toUpperCase();
                        }
                        return tempValue;
                    }else{
                        return "";
                    }*/
                },
                set:function(value) {
                    /*if(value){
                        if(this.trim){
                            value = $.trim(value);
                        }
                        if(this.uppercase){
                            value = value.toUpperCase();
                        }
                    }*/
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            inputBlur(event){
                if(this.newValue){
                    if(this.trim){
                        let tempVal = $.trim(this.newValue);
                        if(this.uppercase){
                            this.newValue = tempVal.toUpperCase();
                        }else{
                            this.newValue = tempVal;
                        }
                    }else{
                        if(this.uppercase){
                            this.newValue = this.newValue.toUpperCase();
                        }
                    }
                }
                this.$emit('blur',event);
            },
            inputChange(val){
                this.$emit('change',val);
            },
            inputFocus(event){
                if(this.focusSelect){
                    this.$refs['zmInput'].$el.children[0].select();
                }
                this.$emit('focus',event);
            },
            select(){
                this.$refs['zmInput'].select();
            },
            focus(){
                this.$refs['zmInput'].focus();
            },
            blur(){
                this.$refs['zmInput'].blur();
            }
        },
        created(){
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ZmInput/index.vue